// client/src/pages/Terms.js
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, delay },
});

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#05040f] text-white px-6 md:px-20 py-16">
      <motion.div
        {...fadeUp(0.05)}
        className="max-w-4xl mx-auto text-center mb-10"
      >
        <Link to="/" className="inline-flex items-center justify-center gap-3">
          <img src="/logo.png" alt="smsorbit" className="w-10 h-10 rounded-xl" />
          <span className="text-xl font-bold tracking-wide">SMSOrbit</span>
        </Link>
        <h1 className="mt-6 text-3xl md:text-4xl font-bold">
          Terms &amp; Conditions
        </h1>
        <p className="mt-3 text-gray-400 text-sm md:text-base max-w-2xl mx-auto">
          By registering or using SMSOrbit you agree that you have read and
          accepted these terms.
        </p>
      </motion.div>

      <motion.div
        {...fadeUp(0.1)}
        className="max-w-4xl mx-auto rounded-3xl bg-[#090912] border border-white/5 p-8 md:p-10 text-sm md:text-base text-gray-200 space-y-4 leading-relaxed"
      >
        <h2 className="font-semibold text-lg">1. General</h2>
        <p>
          By placing an order with SMSOrbit you automatically accept all terms on
          this page whether you read them or not. We reserve the right to update
          the terms of service at any time. You are responsible for keeping
          yourself up to date before placing new orders.
        </p>
        <p>
          You agree to use SMSOrbit only in a way that follows the terms and
          policies of each social network (Instagram, YouTube, TikTok, Facebook,
          etc.). Our services are meant to improve your visibility and
          appearance, not to abuse or harm any platform.
        </p>

        <h2 className="font-semibold text-lg pt-4">2. Delivery</h2>
        <p>
          Delivery times are always estimates. Because social networks and
          providers can change without notice, we cannot guarantee exact start
          time or speed. Orders that are still processing cannot be refunded
          simply because they are taking longer than expected.
        </p>
        <p>
          We always aim to deliver the amount mentioned in the service
          description. However, in case of platform updates or drops we may
          adjust service type or refill rules to complete the order in the best
          possible way.
        </p>

        <h2 className="font-semibold text-lg pt-4">3. Liability</h2>
        <p>
          SMSOrbit is not responsible for any account suspension, bans or content
          removals made by social networks. You are fully responsible for your
          accounts and content.
        </p>

        <h2 className="font-semibold text-lg pt-4">4. About Services</h2>
        <ul className="list-disc ml-5 space-y-1">
          <li>
            SMSOrbit is used to promote your social profiles and help improve
            their visibility.
          </li>
          <li>
            We do not guarantee that new followers or viewers will interact with
            you beyond delivery.
          </li>
          <li>
            Not all accounts will have profile pictures, bios or posts, although
            we aim for high quality.
          </li>
          <li>
            You must not order services for content that violates any platform
            rules or local laws.
          </li>
        </ul>

        <h2 className="font-semibold text-lg pt-6">5. Privacy Policy</h2>
        <p>
          We take your privacy seriously. Any personal information we collect is
          used only to operate your account, process orders and provide support.
          We will never sell or share your personal data with third parties for
          marketing purposes.
        </p>
        <p>
          All sensitive information is stored on secure servers and transmitted
          over encrypted connections where applicable.
        </p>

        <h2 className="font-semibold text-lg pt-6">6. Refund Policy</h2>
        <p>
          Deposits are non-refundable. Once funds are added to your SMSOrbit
          balance, they can only be spent on services inside the panel.
        </p>
        <p>
          If an order is partially delivered or cannot be completed, the
          remaining amount will be automatically refunded to your SMSOrbit
          balance. From there you can place new orders.
        </p>
        <p>
          Chargebacks and payment disputes are not allowed. Opening a dispute
          may result in suspension of your account and removal of previously
          delivered services.
        </p>
      </motion.div>
    </div>
  );
}
